import type { Notification } from '@cabgo/shared';
import { X } from 'lucide-react';
import { getNotificationIcon } from './notificationIcons';

interface NotificationToastProps {
  toast: Notification | null;
  onDismiss: () => void;
  onClick: (toast: Notification) => void;
}

export function NotificationToast({ toast, onDismiss, onClick }: NotificationToastProps) {
  if (!toast) return null;

  return (
    <div className="notification-toast-container" aria-live="polite">
      {/* biome-ignore lint/a11y/useSemanticElements: interactive toast container with inner dismiss button */}
      <div
        className="notification-toast"
        role="button"
        tabIndex={0}
        onClick={() => onClick(toast)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick(toast);
          }
        }}
      >
        <div className="notification-toast__icon">{getNotificationIcon(toast.type, 20)}</div>
        <div className="notification-toast__content">
          <div className="notification-toast__title">{toast.title}</div>
          <div className="notification-toast__body">{toast.body}</div>
        </div>
        <button
          type="button"
          className="notification-toast__close"
          onClick={(e) => {
            e.stopPropagation();
            onDismiss();
          }}
          aria-label="ปิด"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
